import { useLoaderData } from '@remix-run/react';
import Section from '~/components/section.tsx';
import { type IndexLoaderData } from '../Types.ts';

interface MissionListItemProps {
  text: string;
}

function MissionListItem({ text }: MissionListItemProps) {
  return <li>{text}</li>;
}

export function About() {
  const { mission } = useLoaderData<IndexLoaderData>();

  return (
    <Section id="about" className="bg-primary">
      <div className="sm:m-auto sm:max-w-[1400px]">
        <div className="m-5 text-center text-2xl leading-relaxed text-primary-foreground sm:m-10 md:m-20 md:text-5xl md:leading-relaxed">
          {mission.statement}
        </div>
        <div className="m-5 text-center text-2xl leading-relaxed text-primary-foreground sm:m-10 md:m-20 md:text-5xl md:leading-relaxed">
          {mission.work.title}
          <div className="flex flex-col items-center justify-center">
            <ul className="list-inside list-disc text-left text-sm md:text-2xl">
              {mission.work.list.map((item) => (
                <MissionListItem key={item} text={item} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  );
}
